import types from './actionTypes';

const initialState = {
    leftPanelOpen: false,
};

export default function(state = initialState, { type, payload }) {
    switch (type) {
        case types.TOGGLE_LEFT_PANEL:
            return {
                ...state,
                leftPanelOpen: payload.toggle === undefined ? !state.leftPanelOpen : Boolean(payload.toggle),
            };

        default:
            return state;
    }
}
